import React from 'react';
import Button from '@mui/material/Button';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { paths } from '../store/routePaths';
import { fluidPadding, media } from '../utils/styles';

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const home = location.pathname === '/';
  return (
    <Wrapper>
      <nav>
        <Button component="a" onClick={() => navigate('/')}>
          Home
        </Button>

        <Button component="a" onClick={() => navigate(paths.buy)}>
          Buy
        </Button>

        <Button component="a" onClick={() => navigate(paths.sell)}>
          Sell
        </Button>
        <Button component="a" onClick={() => navigate(paths.learn)}>
          Learn
        </Button>
        <Button component="a" onClick={() => navigate(paths.faqs)}>
          FAQs
        </Button>
        <Button component="a" onClick={() => navigate(paths.contact)}>
          Contact
        </Button>
      </nav>
      <Button component="a" onClick={() => navigate(paths.termsofuse)}>
        Terms Of Use
      </Button>
      <Button component="a" onClick={() => navigate(paths.privacy)} className="privacy">
        Privacy Policy
      </Button>

      {home && (
        <Button className="top" onClick={() => window.location.assign('/#')}>
          <ArrowUpwardIcon />
        </Button>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.footer`
  ${fluidPadding};
  padding-top: 1em;
  padding-bottom: 1em;
  display: grid;
  z-index: 1000;
  height: 350px;
  min-height: 350px;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, auto);
  ${media.greaterThan('sm')`
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, auto);
  `};
  justify-content: space-between;
  text-align: center;
  gap: 2em 0;
  background-color: #dadbdd;

  a {
    color: rgba(0, 0, 0, 0.87);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      background-color: rgba(0, 0, 0, 0.05);
    }
  }

  button {
    font-weight: 400;
    align-self: center;
    justify-self: center;
  }

  nav {
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .top {
    border: 1px solid #ccc;
    justify-self: center;
    button {
      border-radius: 0;
      margin: 0;
    }
    & svg {
      color: ${props => props.theme.colors.navyBlue};
    }
  }

  .privacy {
    ${media.greaterThan('sm')`
    justify-self: center;
    `};
  }

  ${media.greaterThan('md')`
    grid-template-columns: 4fr repeat(2, auto);
    grid-template-rows: 1fr;
    height: 75px;
    min-height: 75px;
    justify-content: space-between;
    align-items: center;
    nav {
      flex-direction: row;
    }
    .top {
      margin-left: 2em;
    }
  `}
`;
